import { Contract } from "src/app/public/account/models/contract.model";
import { DealerCriteria } from "src/app/public/account/models/dealer-criteria.model";
import { Dealer } from "src/app/public/account/models/dealer.model";
import { CarCriteria } from "src/app/public/car/models/car-criteria.model";
import { JobCriteria } from "src/app/public/keep/models/job-criteria.model";



export class SearchStoreUtils{

    public static updateCountriesToCarCriteria = ( criteria: CarCriteria,  countries: string[] ) => {
        
        let temp: CarCriteria = criteria == undefined ? new CarCriteria() : JSON.parse(JSON.stringify(criteria));

        temp.countries = countries;
        temp.cities = [];

        return temp;
    }

    public static updateCountriesToDealerCriteria = ( criteria: DealerCriteria,  countries: string[] ) => {
        
        let temp: DealerCriteria = criteria == undefined ? new DealerCriteria() : JSON.parse(JSON.stringify(criteria));

        temp.countries = countries;
        temp.cities = [];

        return temp;
    }

    public static updateCountriesToJobCriteria = ( criteria: JobCriteria,  countries: string[] ) => {
        
        let temp: JobCriteria = criteria == undefined ? new JobCriteria() : JSON.parse(JSON.stringify(criteria));

        temp.countries = countries;
        temp.cities = [];

        return temp;
    }

        public static upsertContractInDealers = ( dealersIn: Dealer[], contract: Contract ) => {
            
            //let temp: Dealer = Object.assign(new Dealer(), dealerData); 
            let dealers: Dealer[] = JSON.parse(JSON.stringify(dealersIn));

            let cntrct: Contract = Object.assign(new Contract(), contract); 

            return dealers.map( dealer => {
                if(dealer.username === contract.customerId){
                    if(dealer.customerContracts == undefined){
                        dealer.customerContracts = [];
                    }
        
                    let index = dealer.customerContracts.findIndex(item => item.contractId === contract.contractId)!;
        
                    if(index >= 0){
                        dealer.customerContracts.splice(index, 1, cntrct);
                    }
                    
                    else{
                        dealer.customerContracts.push(Object.assign(new Contract(), contract));
                    }
                }

                if(dealer.username === contract.providerId){
                    if(dealer.providerContracts == undefined){
                        dealer.providerContracts = [];
                    }
        
                    let index = dealer.providerContracts.findIndex(item => item.contractId === contract.contractId)!;
        
                    if(index >= 0){
                        dealer.providerContracts.splice(index, 1, cntrct);
                    }
                    
                    else{
                        dealer.providerContracts.push(Object.assign(new Contract(), contract));
                    }
                }

                return dealer
            })
        }
    
        public static deleteContractInDealers = ( dealersIn: Dealer[],  contractId: string ) => {
            
            //let temp: Dealer = Object.assign(new Dealer(), dealersIn);
            let dealers: Dealer[] = JSON.parse(JSON.stringify(dealersIn));

            return dealers.map( dealer => {

                //let temp: Dealer = Object.assign(new Dealer(), dealer);

                let index = dealer.customerContracts.findIndex(appt => appt.contractId === contractId)!;
                dealer.customerContracts.splice(index, 1);
        
                index = dealer.providerContracts.findIndex(appt => appt.contractId === contractId)!;
                dealer.providerContracts.splice(index, 1);

                return dealer
            })
    
        }


}
